import supersedeDiacritics from '~/utils/supersedeDiacritics.ts'

const defaultSettings = {
  // These symbols will be cut out
  cutoutRegex: /'/g,
  // These symbols will be replaced with a separator
  replaceRegex: /[^a-z0-9]/g,
  separator: '-',
}

const getSlug = (string?: string, settings = defaultSettings) => {
  const { cutoutRegex, replaceRegex, separator } = settings

  if (!string) return ''

  let slug = string

  // Supersede 'è' with 'e'
  slug = supersedeDiacritics(slug)
  // Lowercase
  slug = slug.toLowerCase()
  // Cut out apostrophes
  slug = slug.replace(cutoutRegex, '')
  // Supersede everything (except what our routes.php regex allows for) with dashes
  slug = slug.replace(replaceRegex, separator)
  // Change all '-*' to '-'
  slug = slug.replace(new RegExp(`${separator}+`, 'g'), separator)
  // Supersede /-$/ with ''
  slug = slug.replace(new RegExp(`${separator}$`), '')
  // Supersede /^-/ with ''
  slug = slug.replace(new RegExp(`^${separator}`), '')

  return slug
}

export default getSlug
